export default "__VITE_ASSET__BTfD$8ZT__"